import {each} from 'lodash';

const hideButtonOnRight = (button) => {
    setTimeout(() => {
        const buttonWidth = button.offsetWidth;
        button.style.marginRight = -(buttonWidth - 45) + 'px';
    }, 150)
}

const displayButton = (button) => {
    button.style.marginRight = '0px';
}

export default class RightFloatingShortcuts {

    static hideButtonsOnRightSide() {
        const viewWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (viewWidth >= 768) {
            const buttons = document.getElementById('right-floating-shortcuts').querySelectorAll('.btn');
            each(buttons, (button) => {
                setTimeout(() => {
                    hideButtonOnRight(button);
                }, 1000);
                button.addEventListener('mouseenter', () => {
                    displayButton(button);
                })
                button.addEventListener('mouseleave', () => {
                    setTimeout(function() {
                        hideButtonOnRight(button);
                    }, 0);
                }, false);
            });
        }
    }
}
